export const DISPLAY_LANGUAGE = "displayLanguage";
const KIDS = "kids";

export function getMasterProfile(allProfile) {
  const masterProfiles = allProfile.filter(profile => profile.isMasterProfile);
  return masterProfiles.length > 0 ? masterProfiles[0] : null;
}

export function onChangeUserLanguage(selectedLanguage, availableLanguages, previousFocus) {
  const { setFocus } = this.props;
  let languageList = [...availableLanguages];
  const languageListWithActiveLang = detectActiveLanguage(languageList, selectedLanguage);
  const { items } = this.state;
  items.forEach(item => {
    if (item.key === DISPLAY_LANGUAGE) {
      item.description = selectedLanguage.title;
    }
  });
  this.setState({
    selectedLanguage: selectedLanguage,
    languageList: languageListWithActiveLang,
    items: items,
    isUserChangeAnything: true
  });
  setFocus(previousFocus);
  previousFocus = null;
}

export function detectActiveLanguage(languageList, selectedLanguage) {
  languageList.forEach(langDetail => {
    if (langDetail.languageCode === selectedLanguage.languageCode) {
      langDetail.active = true;
    } else {
      langDetail.active = false;
    }
  });
  return languageList;
}

export function isKidsProfile(profile) {
  return !!(profile && profile.profileCategory.toLowerCase() === KIDS);
}
